const eventList = document.querySelector('.events-list');

if (eventList) {
  const urlParams = ['locations', 'types', 'audiences', 'pageNumber'];

  const getExtraFormDataInput = (parent, searchInput) => ({
    searchTerm: searchInput || getSearchedData(parent),
    postType: parent.querySelector('[data-post-type]').value,
    locations: getCheckedData(parent, 'locations'),
    types: getCheckedData(parent, 'types'),
    audiences: getCheckedData(parent, 'audiences'),
  });

  // Filter click
  attachEvent('.events-list .mod-filter .dropdown__list-item input', 'click', (ev) => {
    const parent = ev.target.closest('.events-list');
    axiosGetPaginateAndFilteredPosts(parent, 1, urlParams, getExtraFormDataInput(parent));
  });

  // Load more
  attachEvent('.events-list .events-list__footer .btn', 'click', (ev) => {
    const parent = ev.target.closest('.events-list');
    const dataPageNumber = ev.target.closest('[data-page-number]');
    const currentPage = parseInt(dataPageNumber?.getAttribute('data-page-number'), 10) || 1;
    const nextPage = currentPage + 1;
    dataPageNumber.setAttribute('data-page-number', nextPage);

    axiosGetPaginateAndFilteredPosts(parent, nextPage, urlParams, getExtraFormDataInput(parent), false);
  });
}
